import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { connectCompanyPage, ModalAddProjectPage } from './connectCompany';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    connectCompanyPage,
    ModalAddProjectPage,
  ],
  imports: [
    IonicPageModule.forChild(connectCompanyPage),
    CalendarModule,
    NgxPaginationModule,
  ],

  entryComponents: [
    ModalAddProjectPage,
  ],
  providers: [
    RestProvider,
  ]
})
export class ConnectCompanyPageModule {}



// WEBPACK FOOTER //
// ./src/pages/connectCompany/connectCompany.module.ts